export default __webpack_public_path__ + "static/media/call-numbers.0f29f762.svg";